// extracted by mini-css-extract-plugin
module.exports = {"DotNavigation":"DotNavigation_DotNavigation__3WTEu","Dot":"DotNavigation_Dot__UG15j","Clickable":"DotNavigation_Clickable__2poW9","CustomDot":"DotNavigation_CustomDot__26v66"};